import axios from '../../../../utills/axiosConfig';

export const fetchColors = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/colors', { params });
  return res.data;
};

export const addColor = async (color) => {
  try {
    const res = await axios.post('/colors', color);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateColor = async (id, color) => {
  const res = await axios.put(`/colors/${id}`, color);
  return res.data;
};

export const deleteColor = async (id) => {
  const res = await axios.delete(`/colors/${id}`);
  return res.data;
};

export const importColorCSV = async (formData) => {
  const { data } = await axios.post('/colors/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 